// extracted by mini-css-extract-plugin
module.exports = {"Cell":"Navigation_Cell__gayAW","Title":"Navigation_Title__ZHK4A","Table":"Navigation_Table__3C0ro","Block":"Navigation_Block__1eCkP","Brick":"Navigation_Brick__3sGz2"};